import { Component, EventEmitter, Input, Output, OnInit, SimpleChanges, OnChanges, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from '../../../core/services/auth.service';
import { User } from '../../../core/models/user.interface';
import { SUBSCRIPTION_TYPES } from '../../../core/shared/constants';

@Component({
  selector: 'app-complete-data-profile',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './complete-data-profile.component.html',
  styleUrls: ['./complete-data-profile.component.scss'] // <-- también corrige esto
})
export class CompleteDataProfileComponent implements OnChanges {
  @Input() isVisible: boolean = true;
  @Output() closeDialogEvent = new EventEmitter<void>(); // <-- esto es clave

  private authService: AuthService = inject(AuthService);
  user: User | null = null;

  constructor(private router: Router) {}

   ngOnChanges(changes: SimpleChanges): void {
     if (changes['isVisible'] && changes['isVisible'].currentValue) {
       this.loadUserData();
     }
   }
   

  navigateToProfileView() {
    this.closeDialog(); // <- para cerrar el modal
    this.router.navigate(['/dashboard/edit-profile']);
  }

  closeDialog() {
    this.isVisible = false;
    this.closeDialogEvent.emit(); // <-- aquí notificas al padre
    //this.router.navigate([this.getDashboardRoute()]);
  }

  /**
   * Carga los datos del usuario
   */
  private loadUserData(): void {
    this.user = this.authService.getUser();
  }

  /**
   * Verifica si el usuario es Customer/Cliente
   */
  isCustomerUser(): boolean {
    return !!(
      this.user &&
      this.user.type &&
      this.user.type.id === 1 // Customer/Cliente
    );
  }

  /**
   * Verifica si el usuario es Executive
   */
  isExecutiveUser(): boolean {
    return !!(
      this.user &&
      this.user.type &&
      this.user.type.id === 1 && // Customer
      this.user.type.suscriptionType &&
      this.user.type.suscriptionType.id === SUBSCRIPTION_TYPES.Executive.id.toString()
    );
  }

  /**
   * Obtiene la ruta correcta para el dashboard
   */
  getDashboardRoute(): string {
    return this.isExecutiveUser() ? '/dashboard/dashboard-executive' : '/dashboard/dashboard-menu';
  }
}
